<script>
export default {
  name: "cars",
  props: {
    schedule: {
      type: Object,
      default: null
    },
  },
  computed: {
    getStaffs(){
      let staffs = this.schedule.assigned_staffs_by_schedule;
      let res = [];
      res = staffs.map(function(staff){
        return staff.user_name;
      });
      return res.join(" , ");
    }
  }
}
</script>

<template>
  <div v-if="getStaffs" v-html="getStaffs" class="content-area"></div>
</template>

<style scoped lang="scss">
.content-area {
  padding: 10px;
  background: #f8f9fa;
  width: 100%;
}
</style>
